import { isTravelWalletEmpty } from 'components/Pages/Admin/GuestPortal/TravelWallet';
import { LANDING_PAGE_ROLES } from 'constants/index';
// eslint-disable-next-line import/named
import { insert } from 'ramda';
import isNoData from 'utils/isNoData';

import { memoize } from '../../common';

export const travelWalletHeaderId = 'travelWalletHeaderId';
export const guestsFormsHeaderId = 'guestsFormsHeaderId';
export const realocationsHeaderId = 'realocationsHeaderId';

/**
 * Prepares Itinerary that is located within Guest Portal landing
 */
export const prepareItineraryWithinGuestPortal = (itinerary, { hideCosts = false } = {}) => {
  const pages = (itinerary.landing?.pages ?? [])
    .map((page) => {
      if (page.role === LANDING_PAGE_ROLES.SAFARI_COSTS) {
        return hideCosts ? null : page;
      }

      return page;
    })
    .filter(Boolean);

  return {
    ...itinerary,
    landing: {
      ...itinerary.landing,
      pages,
    },
  };
};

export const prepareProposalPages = (
  guestPortal,
  { hideCosts = false, hideEmergencyContactsIfEmpty = false, hideTravelWalletIfEmpty = false } = {},
) => {
  const pages = (guestPortal.landing?.pages ?? [])
    .map((page) => {
      if (page.role === LANDING_PAGE_ROLES.TRAVEL_WALLET) {
        if (hideTravelWalletIfEmpty && isTravelWalletEmpty(guestPortal)) return null;

        return { ...page, titleMountNodeId: travelWalletHeaderId };
      }

      if (page.role === LANDING_PAGE_ROLES.SAFARI_COSTS) {
        return hideCosts ? null : page;
      }

      if (page.role === LANDING_PAGE_ROLES.GUESTS) {
        return { ...page, titleMountNodeId: guestsFormsHeaderId };
      }

      if (page.role === LANDING_PAGE_ROLES.SAFARI_MANIFEST) {
        const blocks = (page.blocks ?? []).map((block) => ({ ...block, withoutRemoving: false }));

        return {
          ...page,
          blocks: hideEmergencyContactsIfEmpty ? filterEmptyContactsFromSafariManifestBlocks(blocks) : blocks,
        };
      }

      if (page.role === LANDING_PAGE_ROLES.RELOCATIONS) {
        return { ...page, titleMountNodeId: realocationsHeaderId };
      }

      return page;
    })
    .filter(Boolean);

  return {
    ...guestPortal,
    landing: {
      ...guestPortal.landing,
      pages,
    },
  };
};

// a very hack-ish way to check whether the emergency contacts are empty
// and if it's true -- filter any blocks that belong to contacts
export const filterEmptyContactsFromSafariManifestBlocks = (blocks) => {
  const safariManifestBlockIdx = blocks.findIndex((block) => block.type === 'safari_manifest');

  // assume that emergency contacts blocks go right after 'safari_manifest' block
  const emergencyContactsBlocks = blocks.slice(safariManifestBlockIdx + 1);
  if (isNoData(emergencyContactsBlocks)) return blocks;

  // assume that first block of emergency blocks is a title and second is a text; if not -- bail
  const [subtitleBlock, textBlock] = emergencyContactsBlocks;
  if (subtitleBlock?.type !== 'subtitle' || textBlock?.type !== 'text') {
    return blocks;
  }

  // if contacts text block is empty then filter everything that goes after 'safari_manifest'
  // again(!) it is assumed that there is nothing except emergency contacts blocks goes after the 'safari_manifest' blocks
  if (isNoData(textBlock.data?.raw?.blocks) || textBlock.data.raw.blocks.every((block) => isNoData(block.text))) {
    return blocks.slice(0, safariManifestBlockIdx + 1);
  }

  return blocks;
};

export const prepareItineraryWithinPDF = memoize((itineraryEntity) => {
  const pages = insert(
    0,
    {
      role: LANDING_PAGE_ROLES.COVER_PAGE,
      primaryImageUrl:
        itineraryEntity?.itinerary?.primaryImageVersion800 || itineraryEntity?.itinerary?.primaryImageUrl,
      primaryImageCoords: itineraryEntity?.itinerary?.primaryImageCoords,
    },
    itineraryEntity?.landing?.pages ?? [],
  );

  return {
    ...itineraryEntity,
    ...(itineraryEntity.itinerary ?? {}),
    // it's a hack only for itineraries and gps inside GP, need to make a single representer for all places on BE
    travelDates: itineraryEntity?.itinerary?.proposedDates || itineraryEntity.travelDates,
    landing: {
      ...itineraryEntity.landing,
      pages,
    },
  };
});
